import { createAsyncThunk } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";
import type { AdminBalanceAdjustmentListVM } from "@shared-kernel/application/ports/admin/admin-repository";

export const retrieveBalanceAdjustments = createAsyncThunk<AdminBalanceAdjustmentListVM[], void, { extra: Partial<Dependencies> }>(
  "balanceAdjustments/retrieveBalanceAdjustments",
  async (_: void, { extra: { adminRepository } }) => {
    return adminRepository!.listBalanceAdjustments();
  },
);
